import { Component, Input } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Action, ActionType } from 'src/app/models/action';

@Component({
  selector: 'app-hold-button',
  templateUrl: './hold-button.component.html',
  styleUrls: ['./hold-button.component.scss', '../base-button.scss'],
})
export class HoldButtonComponent extends BaseButtonComponent {
  @Input()
  isMoreOption: string;

  @Input()
  recordIcon: string;

  hold() {
    const action: Action = {
      type: ActionType.HOLD,
      recordId: this.record.id,
    };

    this.doAction(
      () => {
        this.analyticsService.sendHoldStartEvent();
        this.holdsFacade
          .postHold(
            this.record.id,
            this.getCurrentScreen(),
            this.issueDate,
            this.rhId
          )
          .subscribe({
            next: () => {
              this.toastService.showToast('messages.holds.new');
              this.analyticsService.sendHoldEndEvent();
              this.waiting = false;
            },
            error: (error) => {
              this.waiting = false;
              throw error;
            }
          });
      },
      action,
      true
    );
  }
}
